import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsDataBrokerInterface } from '../../../stats/data/broker.interface';
import { GtmStatsDataBrokerInterface } from '../data/broker.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { GtmStatsAdapterList } from './list';

export class GtmStatsAdapterBroker implements StatsAdapterInterface {
  /**
   *
   * @param rawData
   * @param context
   */
  constructor(protected rawData: StatsDataBrokerInterface, protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataBrokerInterface {
    const listAdapter = new GtmStatsAdapterList(this.context);

    return {
      id: (this.rawData.id || '').toString(),
      name: 'Broker', // yes, it's weird, but we are supposed to send 'Broker', and not the broker's name
      price: '0',
      category: '',
      variant: '',
      position: String(this.rawData.position || ''),
      quantity: 1,
      dimension4: '',
      dimension5: '',
      dimension6: '',
      dimension7: '',
      dimension8: '',
      dimension9: '',
      dimension10: '',
      dimension11: '',
      dimension12: '',
      dimension13: '',
      dimension14: (this.rawData.id || '').toString(),
      dimension15: '',
      dimension16: '',
      dimension17: '',
      dimension18: '',
      dimension19: '',
      dimension20: '',
      dimension21: '',
      dimension24: '',
      dimension29: '',
      dimension53: '',
      promotion: !!this.rawData.isSmartAd,
      list: listAdapter.getData(),
    };
  }
}
